

































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';
import { LineValue } from '@/interfaces';

@Component
export default class DeviceDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;
  public version = '1';

  public async approvalChanged(rec) {
    if (rec.approval_id) {
      const response = await this.api.getRecord(
        this.$store,
        '/deviceapprovals/' + rec.approval_id
      );
      if (response) {
        const data: any = response.data;
        rec.desc = data.desc;
        rec.devicecertificatelayout_id_nl = data.devicecertificatelayout_id_nl;
        rec.devicecertificatelayout_id_fr = data.devicecertificatelayout_id_fr;
        rec.devicereportlayout_id_nl = data.devicereportlayout_id_nl;
        rec.devicereportlayout_id_fr = data.devicereportlayout_id_fr;
        rec.devicetest_id = data.devicetest_id;
        rec.supplier_address_id = data.supplier_address_id;
        // Update detail fields with version key - triggers render
        this.version = String(Number(this.version) + 1);
        if (rec.devicetype_id !== data.devicetype_id) {
          rec.devicetype_id = data.devicetype_id;
          // Update device lines
          this.getDeviceTypeLines();
        }
      }
    }
  }

  public initDeviceGroupId(rec) {
    if (rec.devicetype.devicegroup_id) {
      this.setDeviceGroupID(rec.devicetype.devicegroup_id);
    }
  }

  // Get lines of the selected device type
  public async getDeviceTypeLines() {
    const ref: any = this.$refs.layout;
    const id = ref.rec.devicetype_id;
    if (id) {
      const response = await this.api.getLines(
        this.$store,
        '/devicetypes/' + id
      );
      if (response) {
        const lines: LineValue[] = [];
        for (const line of response.data.data) {
          const l: LineValue = {
            id: 0,
            devicetypeline_id: line.id,
            value: line.default,
            value_index: line.default_index,
            linedatatype: line.linedatatype,
            name: line.name,
            title_nl: line.title_nl,
            title_fr: line.title_fr,
            values_fr: line.values_fr,
            values_nl: line.values_nl
          };
          lines.push(l);
        }
        ref.rec.devicelines = lines;
        // Let detail layout component know that something changed
        ref.$refs.form.$emit('input');
      }
    }
  }
}
